import { render, staticRenderFns } from "./kol_entity_post_list.vue?vue&type=template&id=2fcbcd5f&"
import script from "./kol_entity_post_list.vue?vue&type=script&lang=js&"
export * from "./kol_entity_post_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports